'use strict';

import controller from './datos-integrantes.controller';
import template from './datos-integrantes.html';

const DatosIntegrantesComponent = {
  bindings: {
    integrantes: '='
  },
  controller,
  template
};

export default DatosIntegrantesComponent;



// WEBPACK FOOTER //
// ./src/app/components/empresas/c-empresas/datos-integrantes/datos-integrantes.component.js